// TMS Design System Shadows
// Based on TMS-Design-System.md specifications

export const shadows = {
  // Basic shadow scale
  none: 'none',
  sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  default: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
  md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
  inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',

  // Colored shadows for semantic states
  colored: {
    primary: '0 4px 6px -1px rgba(0, 102, 204, 0.1), 0 2px 4px -1px rgba(0, 102, 204, 0.06)',
    success: '0 4px 6px -1px rgba(40, 167, 69, 0.1), 0 2px 4px -1px rgba(40, 167, 69, 0.06)',
    warning: '0 4px 6px -1px rgba(255, 193, 7, 0.1), 0 2px 4px -1px rgba(255, 193, 7, 0.06)',
    danger: '0 4px 6px -1px rgba(220, 53, 69, 0.1), 0 2px 4px -1px rgba(220, 53, 69, 0.06)',
    info: '0 4px 6px -1px rgba(23, 162, 184, 0.1), 0 2px 4px -1px rgba(23, 162, 184, 0.06)',
  },

  // Component-specific shadows
  component: {
    // Card shadows
    card: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    cardHover: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    cardElevated: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',

    // Button shadows
    button: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    buttonHover: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    buttonActive: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',

    // Modal shadows
    modal: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    modalBackdrop: '0 0 0 1px rgba(0, 0, 0, 0.05)',

    // Dropdown shadows
    dropdown: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    popover: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',

    // Navigation shadows
    sidebar: '2px 0 4px 0 rgba(0, 0, 0, 0.06)',
    header: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',

    // Data display shadows
    table: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    tableRow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',

    // Input shadows
    input: 'inset 0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    inputFocus: '0 0 0 3px rgba(0, 102, 204, 0.1)',
    inputError: '0 0 0 3px rgba(220, 53, 69, 0.1)',
    inputSuccess: '0 0 0 3px rgba(40, 167, 69, 0.1)',

    // Toast/notification shadows
    toast: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    toastSuccess: '0 10px 15px -3px rgba(40, 167, 69, 0.1), 0 4px 6px -2px rgba(40, 167, 69, 0.05)',
    toastWarning: '0 10px 15px -3px rgba(255, 193, 7, 0.1), 0 4px 6px -2px rgba(255, 193, 7, 0.05)',
    toastError: '0 10px 15px -3px rgba(220, 53, 69, 0.1), 0 4px 6px -2px rgba(220, 53, 69, 0.05)',

    // Special effects
    glow: '0 0 20px rgba(0, 102, 204, 0.3)',
    glowSuccess: '0 0 20px rgba(40, 167, 69, 0.3)',
    glowWarning: '0 0 20px rgba(255, 193, 7, 0.3)',
    glowDanger: '0 0 20px rgba(220, 53, 69, 0.3)',
  },

  // Focus ring shadows (for accessibility)
  focus: {
    default: '0 0 0 3px rgba(0, 102, 204, 0.1)',
    primary: '0 0 0 3px rgba(0, 102, 204, 0.1)',
    secondary: '0 0 0 3px rgba(66, 133, 244, 0.1)',
    success: '0 0 0 3px rgba(40, 167, 69, 0.1)',
    warning: '0 0 0 3px rgba(255, 193, 7, 0.1)',
    danger: '0 0 0 3px rgba(220, 53, 69, 0.1)',
    info: '0 0 0 3px rgba(23, 162, 184, 0.1)',
  },
} as const;

// CSS Variables for shadows
export const shadowVariables = {
  '--shadow-sm': shadows.sm,
  '--shadow-default': shadows.default,
  '--shadow-md': shadows.md,
  '--shadow-lg': shadows.lg,
  '--shadow-xl': shadows.xl,
  '--shadow-2xl': shadows['2xl'],
  '--shadow-inner': shadows.inner,

  // Component shadows
  '--shadow-card': shadows.component.card,
  '--shadow-card-hover': shadows.component.cardHover,
  '--shadow-button': shadows.component.button,
  '--shadow-button-hover': shadows.component.buttonHover,
  '--shadow-modal': shadows.component.modal,
  '--shadow-dropdown': shadows.component.dropdown,
  '--shadow-focus': shadows.focus.default,

  // Colored shadows
  '--shadow-primary': shadows.colored.primary,
  '--shadow-success': shadows.colored.success,
  '--shadow-warning': shadows.colored.warning,
  '--shadow-danger': shadows.colored.danger,
  '--shadow-info': shadows.colored.info,
} as const;

// Utility function to create custom shadows
export const createShadow = (
  offsetX: number,
  offsetY: number,
  blurRadius: number,
  spreadRadius: number = 0,
  color: string = 'rgba(0, 0, 0, 0.1)'
): string => {
  return `${offsetX}px ${offsetY}px ${blurRadius}px ${spreadRadius}px ${color}`;
};

// Utility function to combine multiple shadows
export const combineShadows = (...shadows: string[]): string => {
  return shadows.join(', ');
};

// Type definitions
export type Shadow = keyof typeof shadows;
export type ColoredShadow = keyof typeof shadows.colored;
export type ComponentShadow = keyof typeof shadows.component;
export type FocusShadow = keyof typeof shadows.focus;
